import { useCallback, useEffect, useState } from "react";

import { getPaths } from "core/getPaths";
import TransactionsHistory from "shared/Components/TransactionsHistory";
import { useLeague } from "shared/hooks";
import type { PaginationTokenType, ShortPaymentTransactionModel } from "shared/types";

const { league: leagueRoutes } = getPaths();

const pageSize = 10;

interface LeagueTransactionsHistoryProps {
	leagueId: string;
	asPage?: boolean;
}

const LeagueTransactionsHistory: React.FC<LeagueTransactionsHistoryProps> = ({ leagueId, asPage }) => {
	const { getTransactionsHistory, getData: getLeagueData } = useLeague();
	const { loadingPaymentTransactions, paymentTransactions, paymentTransactionsNextToken } = getLeagueData();

	const [paymentTransactionList, setPaymentTransactionList] =
		useState<ShortPaymentTransactionModel[]>(paymentTransactions);

	const fetchData = useCallback(
		async (afterToken?: PaginationTokenType) => {
			const data = await getTransactionsHistory({ id: leagueId, after: afterToken });
			setPaymentTransactionList(c => (!!afterToken ? [...c, ...data.transactions] : data.transactions));
		},
		[getTransactionsHistory, leagueId]
	);

	useEffect(() => {
		fetchData(null);
	}, [fetchData]);

	const handleLoadMore = useCallback(() => {
		paymentTransactionsNextToken && fetchData(paymentTransactionsNextToken);
	}, [paymentTransactionsNextToken, fetchData]);

	return (
		<TransactionsHistory
			transactions={paymentTransactionList}
			loading={loadingPaymentTransactions}
			loadingMore={loadingPaymentTransactions && !!paymentTransactionsNextToken}
			onLoadMore={asPage ? handleLoadMore : undefined}
			exploreAllLink={!asPage ? `${leagueRoutes.getPath()}/${leagueId}/finance/transactions/all` : undefined}
			pageSize={pageSize}
		/>
	);
};

export default LeagueTransactionsHistory;
